// ** Initial State
const initialState = {
  dropdown: [],
  dropdownFormatted: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedMomSurveyGroup: null
}

const momSurveyGroups = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_MOM_SURVEY_GROUPS_DROPDOWN':
      return { 
        ...state, 
        dropdown: action.data,
        dropdownFormatted: action.data.map(item => ({
          label: item.mom_survey_group_name,
          value: item.id,
        }))
      }
    case 'GET_ALL_MOM_SURVEY_GROUPS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_MOM_SURVEY_GROUPS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_MOM_SURVEY_GROUP':
      return { ...state, selectedMomSurveyGroup: action.selectedMomSurveyGroup }
    case 'ADD_MOM_SURVEY_GROUP':
      return { ...state }
    case 'DELETE_MOM_SURVEY_GROUP':
      return { ...state }
    default:
      return { ...state }
  }
}
export default momSurveyGroups
